import { useEffect, useState } from 'react';

const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

export const EASE_OUT = 'cubic-bezier(0.2, 0, 0, 1)';

export const staggerDelay = (index: number, stepMs: number) => `${index * stepMs}ms`;

const getPrefersReducedMotion = () =>
	typeof window !== 'undefined' && window.matchMedia?.(REDUCED_MOTION_QUERY).matches === true;

export const usePrefersReducedMotion = () => {
	const [prefersReducedMotion, setPrefersReducedMotion] = useState(getPrefersReducedMotion);

	useEffect(() => {
		const query = window.matchMedia?.(REDUCED_MOTION_QUERY);
		if (!query) {
			return;
		}

		const update = () => setPrefersReducedMotion(query.matches);
		query.addEventListener?.('change', update);
		return () => query.removeEventListener?.('change', update);
	}, []);

	return prefersReducedMotion;
};
